import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';
import api from '../../../api/chorus';
import * as types from './types';

export default {
  addChorusDoc({ commit }, params) {
    store.dispatch('application/startLoading');
    return api.addChorusDoc(params)
      .then((data) => {
        console.log(data);
        store.dispatch('application/finishLoading');
        router.push({ name: 'ChorusSent' });
        store.dispatch('application/openSnackbar', {
          message: i18n.t('chorus.document.add.success'),
        });
        return data;
      })
      .catch((error) => {
        console.log(error);
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('chorus.document.add.error'),
        });
      });
  },

  searchService({ commit }, siret) {
    store.dispatch('application/startLoading');
    return api.searchService(siret)
      .then((data) => {
        store.dispatch('application/finishLoading');
        return data;
      })
      .catch((error) => {
        console.log(error);
        store.dispatch('application/finishLoading');
        const hasNoChorusAccount = error.response.data.data.errors[0].includes('Aucune information Chorus pour l\'organisation');
        if (hasNoChorusAccount) {
          store.dispatch('application/openSnackbar', {
            message: i18n.t('chorus.get.services.errorChorus'),
          });
        } else {
          store.dispatch('application/openSnackbar', {
            message: i18n.t('chorus.get.services.error'),
          });
        }
      });
  },

  updateChorusConf({ commit }, chorusConf) {
    store.dispatch('application/startLoading');
    return api.updateChorusConf(chorusConf)
      .then(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('chorus.update.conf.success'),
        });
      })
      .catch((error) => {
        store.dispatch('application/finishLoading');
        if (error.response.status === 409) {
          const isAlreayUsed = error.response.data.data.includes('already associated with current guichet user');
          if (isAlreayUsed) {
            store.dispatch('application/openSnackbar', {
              message: i18n.t('chorus.wrong.alreadyUsed.error'),
            });
          } else {
            store.dispatch('application/openSnackbar', {
              message: i18n.t('chorus.wrong.identifiers.error'),
            });
          }
        } else {
          store.dispatch('application/openSnackbar', {
            message: i18n.t('chorus.update.conf.error'),
          });
        }
      });
  },

  breadcrumbSlice(context, params) {
    context.commit(types.BREADCRUMB_SLICE, params);
  },

  updateCurrentGroup(context, object) {
    context.commit(types.BREADCRUMB_UPDATE_CURRENT_GROUP, object);
  },

  breadcrumbPush(context, object) {
    context.commit(types.BREADCRUMB_PUSH, object);
  },

  setBreadcrumbs(context, array) {
    context.commit(types.SET_BREADCRUMBS, array);
  },

  updateAsideElmts(context, array) {
    context.commit(types.UPDATE_ASIDE_ELMTS, array);
  },

  updateViewCard(context, boolean) {
    context.commit(types.UPDATE_VIEW_CARD, boolean);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chorus/actions.js